import React from 'react';
import PropTypes from 'prop-types';


const Spinner = ({ cls }) => (
  <div className="info_none">
    <span className={`ico_blog ico_loading ${cls}`}>로딩중입니다</span>
  </div>
);

Spinner.propTypes = {
  cls: PropTypes.string,
};

Spinner.defaultProps = {
  cls: '',
};

export default Spinner;
